import { type Integration } from '@webapp/platform/integrations/entities'
import { integrationRepository } from '../data-access/repositories'
import { integrationSettingsRepository } from '../data-access/repositories/IntegrationSettingsRepository'

export type LegacyListSyncQueryVariables = {
  localEntity: string
  localEntityRef: number | string
  integrationId: string
}

export const legacyIntegrationKeys = {
  all: ['integrations'] as const,
  details: () => [...legacyIntegrationKeys.all, 'details'] as const,
  detail_id: (id: Integration['id']) =>
    [...legacyIntegrationKeys.details(), id] as const,
  listSync: (filters: LegacyListSyncQueryVariables) =>
    [
      // temporary legacy keys are hard coded
      ...legacyIntegrationKeys.all,
      'listSync',
      {
        localEntity: filters.localEntity,
        localEntityRef: filters?.localEntityRef?.toString(),
        integrationId: filters?.integrationId,
      },
    ] as const,
  getIntegrationSettings: (integrationId: Integration['id']) =>
    [...legacyIntegrationKeys.detail_id(integrationId), 'settings'] as const,
}

export const integrationKeys = {
  all: ['integrationRepository'] as const,
  listIntegrations: () => [...integrationKeys.all, 'listIntegrations'] as const,
  details: () => [...integrationKeys.all, 'details'] as const,
  detail: (id: Integration['id']) =>
    [...integrationKeys.details(), id] as const,
  getIntegrationSettings: (integrationId: Integration['id']) =>
    [...integrationKeys.detail(integrationId), 'settings'] as const,
}

export const integrationQueries = {
  list: () => ({
    queryKey: integrationKeys.listIntegrations(),
    queryFn: () => integrationRepository.listIntegrations(),
  }),
  getIntegrationSettings: (integrationId: Integration['id']) => ({
    queryKey: integrationKeys.getIntegrationSettings(integrationId),
    queryFn: () =>
      integrationSettingsRepository.getIntegrationSettings(integrationId),
  }),
}
